import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cfe2228"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "arrivals" }
const _hoisted_2 = { class: "arrivals_wrap contain_wrap" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"arrivals_wrap_filters\" data-v-2cfe2228><div class=\"arrivals_wrap_filters_item\" data-v-2cfe2228>New arrival</div><div class=\"arrivals_wrap_filters_item\" data-v-2cfe2228>Best Sellers</div><div class=\"arrivals_wrap_filters_item\" data-v-2cfe2228>Exclusive</div><div class=\"arrivals_wrap_filters_item\" data-v-2cfe2228>Men</div><div class=\"arrivals_wrap_filters_item\" data-v-2cfe2228>Women</div><div class=\"arrivals_wrap_filters_item\" data-v-2cfe2228>Kids</div><div class=\"arrivals_wrap_filters_item\" data-v-2cfe2228>Top</div></div>", 1)
const _hoisted_4 = { class: "arrivals_wrap_croce" }
const _hoisted_5 = { class: "img" }
const _hoisted_6 = {
  viewBox: "0 0 253 265",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { "data-animation": "header" }
const _hoisted_10 = {
  class: "_price",
  "data-animation": "header"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn" }, [
  /*#__PURE__*/_createElementVNode("button", null, " See All ")
], -1))

import { IO } from "@/animations/observe";
import croc from "@/db/croce.json";
import { onMounted } from "@vue/runtime-core";


export default /*#__PURE__*/_defineComponent({
  __name: 'arrivals',
  setup(__props) {

const rubberBand = (e: { target: any }) => {
     e.target.classList.toggle("animate__rubberBand");
};

onMounted(() => {
     const elem = document.querySelector(".arrivals")!;
     const observer = new window.IntersectionObserver(
          (entries) => {
               entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                         entry.target.querySelectorAll(".croc_shuu").forEach((item, i) => {
                              setTimeout(() => {
                                   item.classList.toggle("animate__rubberBand");
                              }, i * 150);
                         });
                    }
               });
          },
          { threshold: 0.5, rootMargin: "-30px" }
     );
     observer.observe(elem);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(croc).crocs, (crocs) => {
          return (_openBlock(), _createElementBlock("div", {
            key: crocs.id,
            class: "arrivals_wrap_croce_item"
          }, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                _createElementVNode("path", {
                  d: "M120.447 4.53197C123.254 0.465966 129.262 0.465961 132.07 4.53196L152.72 34.44C154.932 37.6434 159.014 38.9698 162.687 37.6783L196.973 25.6203C201.634 23.9811 206.495 27.5124 206.376 32.4521L205.503 68.7863C205.41 72.678 207.933 76.1506 211.663 77.2643L246.489 87.6622C251.223 89.0757 253.08 94.7896 250.08 98.7161L228.017 127.598C225.654 130.692 225.654 134.984 228.017 138.077L250.08 166.96C253.08 170.886 251.223 176.6 246.489 178.013L211.663 188.411C207.933 189.525 205.41 192.998 205.503 196.889L206.376 233.224C206.495 238.163 201.634 241.695 196.973 240.055L162.687 227.997C159.014 226.706 154.932 228.032 152.72 231.236L132.07 261.144C129.262 265.21 123.254 265.21 120.447 261.144L99.7962 231.236C97.5844 228.032 93.502 226.706 89.8297 227.997L55.5435 240.055C50.8823 241.695 46.0218 238.163 46.1404 233.224L47.0132 196.889C47.1067 192.998 44.5837 189.525 40.8536 188.411L6.02795 178.013C1.2934 176.6 -0.563144 170.886 2.4363 166.96L24.4992 138.077C26.8622 134.984 26.8622 130.692 24.4992 127.598L2.43631 98.7161C-0.563142 94.7896 1.29339 89.0757 6.02794 87.6622L40.8536 77.2643C44.5837 76.1506 47.1067 72.678 47.0132 68.7863L46.1404 32.4521C46.0218 27.5124 50.8823 23.9811 55.5435 25.6203L89.8297 37.6783C93.502 38.9698 97.5844 37.6434 99.7962 34.44L120.447 4.53197Z",
                  fill: crocs.color,
                  stroke: "black",
                  "stroke-width": "1.56936"
                }, null, 8, _hoisted_7)
              ])),
              _createElementVNode("img", {
                onClick: rubberBand,
                class: "croc_shuu animate__animated animate__repeat-1",
                src: require(`@/assets/croc${crocs.id}.svg`),
                alt: ""
              }, null, 8, _hoisted_8)
            ]),
            _createElementVNode("p", _hoisted_9, _toDisplayString(crocs.name), 1),
            _createElementVNode("p", _hoisted_10, "$" + _toDisplayString(crocs.price), 1)
          ]))
        }), 128))
      ]),
      _hoisted_11
    ])
  ]))
}
}

})